import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

const videos = $$(".video-intersection");

if (!isReduced) {
  videos.forEach((video) => {
    ScrollTrigger.create({
      trigger: video,
      start: `top bottom`,
      end: "bottom top",
      once: true,
      onEnter(self) {
        video.setAttribute("autoplay", "autoplay");
        video.play();
        video.classList.add("playing");
        video.classList.remove("paused");
      }
    });
  });

  const intersectionAnimations = $$(".pseudo-circle-intersection, .rotate-circle-intersection");
  intersectionAnimations.forEach((animation) => {
    ScrollTrigger.create({
      trigger: animation,
      start: `top 70%`,
      end: "bottom 30%",
      onEnter(self) {
        animation.classList.add("animate");
      },
      onEnterBack(self) {
        animation.classList.add("animate");
      },
      onLeave(self) {
        animation.classList.remove("animate");
      },
      onLeaveBack(self) {
        animation.classList.remove("animate");
      }
    });
  });

  const stats = $$(".stat");
  const formatter = getFormatter(1);

  stats.forEach((stat) => {
    let toVal = stat.textContent.replace(/\.|,/g, "");
    stat.textContent = 0;

    ScrollTrigger.create({
      trigger: stat,
      start: `top 70%`,
      end: "bottom 30%",
      once: true,
      onEnter(self) {
        gsap.to(stat, {
          textContent: toVal,
          duration: 4,
          ease: "power1.in",
          onUpdate() {
            stat.innerText = formatter(stat.innerText);
          }
        });
      }
    });
  });
}

function getFormatter(increment, pad) {
  let snap = gsap.utils.snap(increment),
      exp = /\B(?=(\d{3})+(?!\d))/g,
      snapWithCommas = value => (snap(+value) + "").replace(exp, ","),
      whole = increment % 1 === 0,
      decimals = whole ? 0 : ((increment + "").split(".")[1] || "0").length;
  return !pad || whole ? snapWithCommas : value => {
    let s = snapWithCommas(value),
        i = s.indexOf(".");
    ~i || (i = s.length);
    return s.substr(0, i) + "." + (s.substr(i + 1, s.length - i - 1) + "00000000").substr(0, decimals);
  };
}